import { render } from "./QualityPage.vue?vue&type=template&id=94cd0db0&scoped=true"
import script from "./QualityPage.vue?vue&type=script&lang=js"
export * from "./QualityPage.vue?vue&type=script&lang=js"

import "./QualityPage.vue?vue&type=style&index=0&id=94cd0db0&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.97.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94cd0db0"]])

export default __exports__